import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import AuthGate from './AuthGate';
import { initInstall, registerServiceWorker } from './lib/pwa';

// CRM-LEADS-2026-10-16 §4: installable app -- keep the browser's install offer for Settings, and register the service worker
initInstall();
if (typeof window !== 'undefined') window.addEventListener('load', () => { registerServiceWorker(); });

// Phase 2a: Supabase Auth kill switch. OFF by default so the CRM keeps working
// before the RLS lockdown (anon requests still allowed under allow_all policies).
// Set REACT_APP_REQUIRE_AUTH=true and rebuild to require email/password login —
// do this together with applying the RLS migration.
// SECURITY-AGENTS-2026-10-14: the gate is ON unless a build says exactly 'false' -- a fresh clone without the
// gitignored .env.production used to ship with no login screen.
const REQUIRE_AUTH = process.env.REACT_APP_REQUIRE_AUTH !== 'false';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(REQUIRE_AUTH ? <AuthGate><App /></AuthGate> : <App />);
